module.exports = __webpack_public_path__ + "img/challenge.f36a06c2.svg";